/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */

/**
 * 活动标签
 */

/**
 * 活动滚动背景图列表
 */

/**
 * 活动滚动背景图id列表
 */

/**
 * 日程列表
 */

/**
 * 嘉宾列表
 */

/**
 * 活动基础信息
 */

const ActivitiesPublicRegistrationPage = async (data, http) => {
  // @ts-ignore
  const res = await http.get('/wemeet-tapi', '/v2/activities/public/registration-page', data);
  return res;
};
export default ActivitiesPublicRegistrationPage;